import { jsxs as i, jsx as t } from "react/jsx-runtime";
import r from "react";
import { withRipple as R } from "@rmwc/ripple";
import { Icon as T } from "@rmwc/icon";
import { useIsWrappedTouchTarget as I } from "@rmwc/touch-target";
import { createComponent as x, useClassNames as d, Tag as C, createMemoComponent as j } from "@rmwc/base";
const D = R({
  surface: !1
})(
  x(function(o, e) {
    const {
      dense: c,
      raised: l,
      unelevated: p,
      outlined: f,
      danger: h,
      icon: u,
      label: b,
      trailingIcon: s,
      children: g,
      touch: B,
      ...m
    } = o, _ = I(B), v = d(o, [
      "mdc-button",
      {
        "mdc-button--dense": c,
        "mdc-button--raised": l,
        "mdc-button--unelevated": p,
        "mdc-button--outlined": f,
        "mdc-button--touch": _
      }
    ]);
    if (h) {
      const N = m.style || {}, y = {
        "--mdc-theme-primary": "var(--mdc-theme-error)",
        "--mdc-theme-on-primary": "var(--mdc-theme-on-error)"
      };
      m.style = {
        ...y,
        ...N
      };
    }
    return /* @__PURE__ */ i(C, { tag: "button", ...m, ref: e, className: v, children: [
      /* @__PURE__ */ t(w, {}),
      /* @__PURE__ */ t(F, {}),
      /* @__PURE__ */ t(S, {}),
      !!u && /* @__PURE__ */ t(a, { icon: u }),
      /* @__PURE__ */ i("span", { className: "mdc-button__label", children: [
        b,
        g
      ] }),
      !!s && /* @__PURE__ */ t(a, { icon: s })
    ] });
  })
), F = r.memo(function() {
  return /* @__PURE__ */ t("div", { className: "mdc-button__touch" });
}), S = r.memo(function() {
  return /* @__PURE__ */ t("div", { className: "mdc-button__focus-ring" });
}), w = r.memo(function() {
  return /* @__PURE__ */ t("div", { className: "mdc-button__ripple" });
}), a = j(
  function(o, e) {
    const c = d(o, ["mdc-button__icon"]);
    return /* @__PURE__ */ t(T, { ...o, className: c, ref: e });
  }
);
export {
  D as Button
};
